export const NotificationType = {
  DOCUMENT_PROCESSING_PROGRESS: 'document_processing_progress',
  DOCUMENT_PROCESSING_COMPLETE: 'document_processing_complete',
  DOCUMENT_PROCESSING_FAILED: 'document_processing_failed',
  DOCUMENT_PROCESSING_STARTED: 'document_processing_started',
};

export const DUE_OCCURRENCE = {
  AFTER: 'After',
  BEFORE: 'Before',
};